<template>

<van-sticky>
    <div class="top-nav">
            <div class="title">
                <div class="inline-block">
                    <van-image width="50" height="50" src="/logo.png" />
                </div>

                <div class="text">
                    <span class="name">小麦</span>
                    <br>
                    <span class="tip">语音畅聊带你邂逅</span>
                </div>

                <div class="btn-outer-layer">
                    <van-button class="btn" type="primary" @click="handleOpenApp">打开看看</van-button>
                </div>

            </div>

    </div>
</van-sticky>
    
</template>

<script>
import { stringify } from 'querystring';

export default {
    name: 'topNav',
    props: {
        appLink: {
            require: false,
            type: String,
            default: null
        },
        timer: ''
    },
    mounted() {

        if (!this.appLink) {
            if (navigator.userAgent.match(/(iPhone|iPod|iPad);?/i)) {
                // this.appLink = 'https://62a5b59.umindex.com'
            } else if (navigator.userAgent.match(/android/i)) {
                // this.appLink = 'sharecard://com.app.siyu'
            }
        }
    },
    beforeDestroy() {
        clearTimeout(this.timer)
    },
    methods: {
        handleOpenApp() {
            if (!this.appLink) return;
            window.location.href = this.appLink;
            this.timer = setTimeout(()=>{
                if (typeof document.hidden !== "undefined") {
                    if (!document.hidden) {
                        window.location.href = process.env.VUE_APP_HERF_APPWEB
                    }
                } else if (typeof document.mozHidden !== "undefined") {
                    if (!document.mozHidden) {
                        window.location.href = process.env.VUE_APP_HERF_APPWEB
                    }
                } else if (typeof document.msHidden !== "undefined") {
                    if (!document.msHidden) {
                        window.location.href = process.env.VUE_APP_HERF_APPWEB
                    }
                } else if (typeof document.webkitHidden !== "undefined") {
                    if (!document.webkitHidden) {
                        window.location.href = process.env.VUE_APP_HERF_APPWEB
                    }
                }
            },2000)
        }
    }
}
</script>

<style lang="less" scoped>
.top-nav {
    background: url('/imgs/titleBg.png');
    background-size: 100% 100%;
    background-repeat: no-repeat;
    height: 70px;
    // backdrop-filter: blur(27px);
    .title {
        // background: rgba(0, 0, 0, .4);
        color: #FFFFFF;
        display: flex;
        // backdrop-filter: blur(7px);
        width: 100%;
        padding: 10px 24px 10px 24px;

        .text {
            margin-left: 10px;

            .name {
                display: inline-block;
                font-size: 16px;
                font-weight: bold;
                line-height: 23px;
            }

            .tip {
                margin-top: 5px;
                display: inline-block;
                font-size: 13px;
                line-height: 20px;
            }
        }

        .btn-outer-layer {
            flex: 1;
            text-align: right;
            margin-top: 9px;

            .btn {
                background: #F9EB34;
                border-color: #F9EB34;
                color: #373737;
                font-size: 13px;
                width: 90px;
                height: 32px;
                border-radius: 25px;
            }
        }
    }
}
</style>